module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Zmiana pakietu")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Email użytkownika")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Telefon użytkownika")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Obecny pakiet")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.user.access.planDefinition.name) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Aktywność pakietu")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm._f("date")(_vm.user.access.startAt)) + " - " + _vm._s(_vm._f("date")(_vm.user.access.endAt)) + "\n          "), (_vm.user.access.isTrial) ? [_vm._v("(okres testowy)")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Zmień na pakiet")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlanDefinition),
      expression: "newPlanDefinition"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newPlanDefinition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- wybierz pakiet --")]), _vm._v(" "), _vm._l((_vm.planDefinitions), function(plan) {
    return _c('option', {
      domProps: {
        "value": plan.id
      }
    }, [_vm._v(_vm._s(plan.name))])
  })], 2)])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Czy okres testowy")]), _vm._v(" "), _c('td', [_c('checkbox-input', {
    attrs: {
      "label": "Okres testowy"
    },
    model: {
      value: (_vm.trial),
      callback: function($$v) {
        _vm.trial = $$v
      },
      expression: "trial"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Na okres")]), _vm._v(" "), _c('td', [_c('date-picker', {
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  }), _vm._v("\n          do\n          "), _c('date-picker', {
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('question-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "question": "Czy na pewno zmienić pakiet temu użytkownikowi"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            Zmień pakiet\n          ")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666ae217","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePackage.vue
// module id = 453
// module chunks = 1